

















import { Component, Prop, Vue } from "vue-property-decorator";

import { TravelIssueResult } from "@/types/all";

@Component
export default class TravelContractForm extends Vue {
  @Prop() data!: Array<TravelIssueResult>;

  public goBack(): void {
    this.$router.push({ name: "travel" });
  }
}
